import cpp from "./assets/icons/c++.svg";
import sql from "./assets/icons/sql.svg"
import java from "./assets/icons/java.svg";
import html from "./assets/icons/html.svg";
import css from "./assets/icons/css.svg";
import tailwind from "./assets/icons/tailwind.svg";
import materialui from "./assets/icons/materialui.svg";
import js from "./assets/icons/js.svg";
import react from "./assets/icons/react.svg";
import nodejs from "./assets/icons/nodejs.svg";
import expressjs from "./assets/icons/expressjs.svg";
import mongodb from "./assets/icons/mongodb.svg";
import postgres from "./assets/icons/postgres.svg";
import vscode from "./assets/icons/vscode.svg";
import git from "./assets/icons/git.svg";
import github from "./assets/icons/github.svg";
import postman from "./assets/icons/postman.svg";
import supabase from "./assets/icons/supabase.svg";
import vercel from "./assets/icons/vercel.svg";
import netlify from "./assets/icons/netlify.svg";
import figma from "./assets/icons/figma.svg";

const programming_languages = [{
    img: cpp,
    name: "C++"
},
{
    img: sql,
    name: "SQL"
},
{
    img: java,
    name: "Java"
}]
const tools = [{
    img: vscode,
    name: "VS Code"
}, {
    img: git,
    name: "Git"
},
{
    img: github,
    name: "Github"
},
{
    img: vercel,
    name: "Vercel"
},
{
    img: netlify,
    name: "Netlify"
},
{
    img: figma,
    name: "Figma"
}]
const frontend_technologies = [{
    img: html,
    name: "HTML"
},
{
    img: css,
    name: "CSS"
},
{
    img: tailwind,
    name: "Tailwind"
},
{
    img: materialui,
    name: "Material UI"
},
{
    img: js,
    name: "Javascript"
},
{
    img: react,
    name: "Reactjs"
}]

const backend_technologies = [{
    img: nodejs,
    name: "Nodejs"
},
{
    img: expressjs,
    name: "Expressjs"
},
{
    img: mongodb,
    name: "MongoDB"
},
{
    img: postgres,
    name: "PostgreSQL"
}, {
    img: postman,
    name: "Postman"
},
{
    img: supabase,
    name: "Supabase"
}]


export { programming_languages };
export { frontend_technologies };
export { backend_technologies };
export { tools };